import { GenIcon } from '../helpers/IconBase.es.js';

const CashColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.435 5C2.195 5 2 5.195 2 5.436V17.609C2 17.849 2.195 18.044 2.435 18.044H21.565C21.806 18.044 22 17.849 22 17.609V5.436C22 5.195 21.806 5 21.565 5H2.435Z",
          fill: "#1CC54F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.9142 6.30505C5.9142 7.74505 4.7452 8.91305 3.3042 8.91305V14.1301C4.7452 14.1301 5.9142 15.2991 5.9142 16.7401H18.0882C18.0882 15.2991 19.2552 14.1301 20.6962 14.1301V8.91305C19.2552 8.91305 18.0882 7.74505 18.0882 6.30505H5.9142Z",
          fill: "#B9F5B4"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.95703 11.522C8.95703 13.203 10.319 14.566 12 14.566C13.681 14.566 15.044 13.203 15.044 11.522C15.044 9.841 13.681 8.479 12 8.479C10.319 8.479 8.95703 9.841 8.95703 11.522Z",
          fill: "#1CC54F"
        }
      }
    ]
  })(props);
};

export { CashColored };
